// extracted by mini-css-extract-plugin
module.exports = {"container":"Expense_container__1mees","block":"Expense_block__1a5Fp"};